import { Center } from '@euler/components/Center';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { StyleProp, Text, ViewStyle } from 'react-native';

export const TextIcon: FC<{
  text: string;
  color: string;
  style?: StyleProp<ViewStyle>;
}> = memo(({ text, color, style }) => {
  const { rpx } = useResponsiveContext();
  return (
    <Center
      css={`
        border-radius: ${rpx(3)}px;
        background-color: ${color};
        padding: 0 ${rpx(4)}px;
      `}
      style={style}
    >
      <Text
        css={`
          font-family: ${FontFamily.NotoSans.Light};
          font-size: ${rpx(10)}px;
          line-height: ${rpx(14)}px;
          color: #fff;
          text-align: center;
        `}
      >
        {text}
      </Text>
    </Center>
  );
});
